var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maintainImg)?_c('img',{attrs:{"src":_vm.maintainImg}}):_c('Spinner',{attrs:{"bgc":"#f6f6f6"}})}
var staticRenderFns = []

export { render, staticRenderFns }